export enum SupplyType {
  GV = "gv",
  NOT_GV = "not_gv",
  SV = "sv",
  NOT_SV = "not_sv",
}

export const getOppositeSupplyType = (current: SupplyType): SupplyType => {
  const positiveFilter = () =>
    [SupplyType.GV, SupplyType.SV].find(
      (productType) => productType === current
    );
  if (positiveFilter()) {
    return `not_${current}` as SupplyType;
  }
  return `${current.replace("not_", "")}` as SupplyType;
};

export const SupplyTypeLabel = {
  [SupplyType.GV]: "Grundversorgung",
  [SupplyType.SV]: "Sondervertrag",
};



// WEBPACK FOOTER //
// ./src/types/SupplyType.tsx